import React from "react";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import { LogoLockup } from "./Logo";
import { useRole } from "../context/RoleContext";
import { navForUser, ROLES } from "../lib/roles";
import { LogOut, UserCircle2 } from "lucide-react";
import NotificationBell from "./NotificationBell";

export default function TopNav() {
  const { role, user, isAnonymous, signOut } = useRole();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  // The Landing page is the public marketing splash — present it as
  // anonymous-only regardless of any background session, so the user
  // can re-pick a role to step into the demo.
  const presentAnonymous = isAnonymous || pathname === "/";
  const items = presentAnonymous ? navForUser(null, null) : navForUser(role, user);

  return (
    <header
      className="w-full"
      style={{ backgroundColor: "#1B1F4B" }}
      data-testid="top-nav"
    >
      <div className="max-w-[1280px] mx-auto px-6 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center" data-testid="brand-link">
          <LogoLockup tone="white" size={28} />
        </Link>

        <nav className="hidden md:flex items-center gap-1" data-testid="primary-nav">
          {items.filter((it) => !it.divider && it.to).map((it) => (
            <NavLink
              key={it.to}
              to={it.to}
              end={it.end === undefined ? it.to === "/" : it.end}
              className={({ isActive }) => `wn-nav-link ${isActive ? "is-active" : ""}`}
              data-testid={`nav-${it.label.toLowerCase().replace(/\s+/g, "-")}`}
            >
              {it.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          {presentAnonymous ? (
            <button
              onClick={() => navigate("/sign-in")}
              className="wn-btn wn-btn-accent"
              data-testid="sign-in-btn"
            >
              Sign in
            </button>
          ) : (
            <>
              <NotificationBell />
              <div
                className="hidden sm:flex items-center gap-2"
                style={{ color: "#FBFAFD" }}
                data-testid="active-user"
              >
                <UserCircle2 size={18} style={{ opacity: 0.75 }} />
                <div className="leading-tight">
                  <div style={{ fontSize: 13, fontWeight: 700 }}>
                    {user?.name || ROLES[role]?.short}
                  </div>
                  <div
                    style={{
                      fontSize: 10,
                      letterSpacing: "0.12em",
                      textTransform: "uppercase",
                      opacity: 0.7,
                    }}
                  >
                    {ROLES[role]?.short}
                  </div>
                </div>
              </div>
              <button
                onClick={() => {
                  signOut();
                  navigate("/");
                }}
                className="wn-btn wn-btn-outline"
                style={{ color: "#FBFAFD", borderColor: "rgba(251,250,253,0.35)" }}
                data-testid="sign-out-btn"
              >
                <LogOut size={16} />
                Sign out
              </button>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
